module.exports = __webpack_public_path__ + "static/media/community-overlay.928f2643.png";